<style lang="less" scoped>

</style>
<template>
  <v-menu
    v-model="showDateMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :max-width="mMaxWidth"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="my_value"
        :label="field.label"
        :placeholder="field.placeholder"
        readonly
        :disabled="field.disabled"
        :clearable="field.clearable"
        v-bind="attrs"
        :rules="field.rules"
        v-on="on"
        @click:clear="clear"
      >
        <template v-slot:label> 
          <span><span
            v-show="field.required"
            style="color:red"
          >*</span>{{ field.label }}</span>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="my_value"
      type="month"
      no-title
      scrollable
      reactive
      :locale="field.locale"
      :allowed-dates="field['allowed-dates']"
      @change="changeDate"
    >
      <v-spacer />
      <v-btn
        v-show="!field.selected_close"
        text
        color="primary"
        @click="showDateMenu = false"
      >
        关闭 
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>
<script>
  export default {
    props: {
      field: {
        type: Object,
        default: () => ({})
      },
      value: {
        type:String,
      },
      mMaxWidth: {
        type:Number,
        default: 290
      }
    },
    data() {
      return {
        showDateMenu: false,
        my_value: this.value
      }
    },

    watch: {
      value(new_val) {
        this.my_value = new_val
      },
      my_value(new_val) {
        this.$emit('input', new_val)
      }
    },
    methods: {
      changeDate() {
        if (this.field.selected_close) {
          this.showDateMenu = false
        }
        this.$emit('change', this.my_value)
      },
      clear() {
        this.my_value = null
        this.$emit('clear', this.my_value)
      }
    }
  }
</script>
